<template>
  <div>
    <b-row align-h="end" class="mx-0 mb-3">
      <Button variant="orange" @click="openFormModal">
        <font-awesome-icon :icon="['fas', 'plus-circle']" fixed-width />
        <span class="pl-1">Solicitar plano</span>
      </Button>
    </b-row>

    <!-- MOBILE: cards -->
    <b-row class="d-xl-none">
      <b-col>
        <template v-if="drawingRequests.length">
          <b-card
            v-for="request in drawingRequests"
            :key="request.id"
            no-body
            class="mb-2 shadow-sm"
          >
            <b-card-body class="p-3">
              <div class="d-flex justify-content-between align-items-start mb-1">
                <b-link :to="requestPath(request.id)" class="related-link fs-14 font-weight-bold">
                  {{ request.request_no }}
                </b-link>
                <b-badge :variant="statusVariant(request.status)">{{ request.status_label }}</b-badge>
              </div>

              <p class="mb-2 fs-14 text-truncate">{{ request.title }}</p>

              <div class="fs-13 text-muted">
                <div class="d-flex justify-content-between">
                  <span>Tipo</span>
                  <span class="text-dark">{{ request.drawing_type_label }}</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span>Fecha requerida</span>
                  <span class="text-dark">{{ request.required_date | formatDate }}</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span>Dibujante</span>
                  <span v-if="request.drafter" class="text-dark">{{ request.drafter | concatName4 }}</span>
                  <span v-else>Sin asignar</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span>Solicitante</span>
                  <span class="text-dark">{{ request.requester | concatName4 }}</span>
                </div>
              </div>

              <div class="text-center">
                <Button size="sm" variant="blue" block class="mt-3" :to="requestPath(request.id)">
                  <span>Ver solicitud</span>
                </Button>
              </div>
            </b-card-body>
          </b-card>
        </template>

        <div v-else class="text-center py-3">
          <p class="fs-14 mb-1">No hay solicitudes de plano registradas</p>
        </div>
      </b-col>
    </b-row>

    <!-- DESKTOP: table -->
    <b-row class="d-none d-xl-block">
      <b-col>
        <b-table
          :items="drawingRequests"
          :fields="fields"
          show-empty
          hover
          responsive
          class="border-bottom fs-14"
        >
          <template #empty>
            <div class="text-center py-3">
              <p class="fs-14 mb-1">No hay solicitudes de plano registradas</p>
            </div>
          </template>

          <template #cell(request_no)="{ item }">
            <b-link :to="requestPath(item.id)" class="related-link">
              {{ item.request_no }}
            </b-link>
          </template>

          <template #cell(status_label)="{ item }">
            <b-badge :variant="statusVariant(item.status)">
              <span class="fs-12">
                {{ item.status_label }}
              </span>
            </b-badge>
          </template>

          <template #cell(required_date)="{ item }">
            {{ item.required_date | formatDate }}
          </template>

          <template #cell(requester)="{ item }">
            {{ item.requester | concatName4 }}
          </template>

          <template #cell(drafter)="{ item }">
            <span v-if="item.drafter">{{ item.drafter | concatName4 }}</span>
            <span v-else class="text-muted">Sin asignar</span>
          </template>

          <template #cell(actions)="{ item }">
            <Button size="sm" variant="blue" block class="float-right" :to="requestPath(item.id)">
              <span>Ver solicitud</span>
            </Button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <!-- New Drawing Request Modal -->
    <DrawingRequestFormModal
      v-if="formModalShow"
      :project="project"
      @close="closeFormModal"
      @created="onDrawingRequestCreated"
    />
  </div>
</template>

<script>
import Button from '../../shared/Button'
import DrawingRequestFormModal from '../drawingRequests/DrawingRequestFormModal'
import { statusVariants } from '../../../sharedOptions/drawingRequestOptions'

export default {
  name: 'DrawingRequestsTab',
  components: { Button, DrawingRequestFormModal },
  props: {
    project: { type: Object, required: true },
    drawingRequests: { type: Array, default: () => [] }
  },
  data () {
    return {
      formModalShow: false,
      fields: [
        { key: 'request_no', label: '# Solicitud' },
        { key: 'title', label: 'Título' },
        { key: 'drawing_type_label', label: 'Tipo' },
        { key: 'drafter', label: 'Dibujante' },
        { key: 'required_date', label: 'Fecha requerida' },
        { key: 'status_label', label: 'Estado' },
        { key: 'requester', label: 'Solicitante' },
        { key: 'actions', label: '' }
      ]
    }
  },
  methods: {
    openFormModal () {
      this.formModalShow = true
    },
    closeFormModal () {
      this.formModalShow = false
    },
    onDrawingRequestCreated (drawingRequest) {
      this.formModalShow = false
      this.$emit('drawing-request-created', drawingRequest)
    },
    statusVariant (status) {
      return statusVariants[status] || 'secondary'
    },
    requestPath (id) {
      return `/app/prod/solicitudes-planos/${id}`
    }
  }
}
</script>
